// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"0adb5ba8","426":"816b1795","900":"53c96c2c"}[chunkId] + ".chunk.css";
};